import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import "./static/css/style.css";
import "./static/css/static_pages.css";

function App() {
  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
}

export default App;
